import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { GetMenu } from '../_navigation/NavMenu';
import SecuredRoute from './SecuredRoute';
import Login from '../Login';
import { INavMenuitem } from '../_navigation/NavMenu';

interface Props {

};

const Router: React.FC<Props> = (props: Props) => {

    //const { nav, setNav } = useContext(NavigationContext);
    //const { user } = useContext(AuthContext);

    
    const getRoute = (item: INavMenuitem) => {

   
        let exact = false;
        if (item.exact) { exact = true; }

        
        return (item.path==='/') ? (
            <SecuredRoute path={item.path} exact checkPermission={item.checkPermission} component={item.component}/>
            ) : 
             
                (!item.external) ? 
                (<SecuredRoute path={item.path} exact={exact} checkPermission={item.checkPermission} component={item.component}/>)
                : (<Route path={item.path} exact={exact}  component={() => {
                    window.location.href=item.external!;
                    return null;
                }}/>
                );
            
            
        


        
        // return (item.path==='/') ? (
        //     <SecuredRoute path={item.path} exact component={item.component}/>
        //    ) : 
        //    ( 
        //        (!item.locationOnly || (item.locationOnly && goodLocation))
        //        ? <SecuredRoute path={item.path} component={item.component}/>
        //        : <Redirect to={{pathname: '/' }} />
        //    );

    }

    return (
        <Switch>
            { GetMenu().map(grp => grp.items.map(
                itm => getRoute(itm)
            ))
            }
            
            <Route path="/login" component={Login} />
        </Switch>
    )
}

export default Router;

